/* ==========================================================================
   Product options - colour / size picker and the bundle picker

   Keeps the hidden variant id, the price row, the add-to-cart label and the
   gallery in step with the chosen colour and size, and puts the chosen
   bundle quantity into the form. Products without options skip all of it.
   ========================================================================== */

(function () {
  'use strict';

  function money(cents) {
    return window.LUVZ && LUVZ.localization ? LUVZ.localization.formatMoney(cents) : (cents / 100).toFixed(2);
  }

  function init(form) {
    var picker = form.querySelector('[data-variant-picker]');
    var bundle = form.querySelector('[data-bundle]');
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[data-qty-input]');
    var btn = form.querySelector('[data-add-btn]');
    var info = form.closest('.pdp__info') || document;
    var gallery = document.querySelector('[data-gallery] [data-slider]');
    var variants = [];
    if (picker) {
      try { variants = JSON.parse(picker.querySelector('[data-variants]').textContent); } catch (e) { variants = []; }
    }
    var current = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];

    function selected() {
      var opts = [];
      picker.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        opts[+r.getAttribute('data-opt-index')] = r.value;
      });
      return opts;
    }

    function unitPrice() { return current ? current.price : 0; }
    function unitWas() { return current && current.compare_at_price > current.price ? current.compare_at_price : unitPrice(); }

    function paintBundle() {
      if (!bundle) return;
      bundle.querySelectorAll('input[data-bundle-qty]').forEach(function (r) {
        var qty = +r.getAttribute('data-bundle-qty');
        var disc = +r.getAttribute('data-bundle-discount') || 0;
        var total = (unitPrice() - Math.floor(unitPrice() * disc / 100)) * qty; // matches Shopify: % off each unit, rounded down
        var before = unitWas() * qty;
        var row = r.closest('.bundle__row');
        var t = row.querySelector('[data-bundle-total]');
        var w = row.querySelector('[data-bundle-was]');
        var sv = row.querySelector('[data-bundle-save]');
        if (t) t.textContent = money(total);
        if (w) w.textContent = money(before);
        if (sv) sv.textContent = 'Save ' + Math.round((before - total) / before * 100) + '%';
      });
    }

    /* ---------- per-item picks for 2 / 3 packs ---------------------------
       One row per item, each with its own colour and size. Row 1 follows the
       main picker; the rest start from it and can be changed freely. The
       chosen variant ids go on the form for assets/cart.js to add. */
    var itemsBox = bundle && bundle.querySelector('[data-bundle-items]');
    var list = itemsBox && itemsBox.querySelector('[data-bundle-list]');
    var optionDefs = [];
    if (picker) {
      picker.querySelectorAll('fieldset[data-opt-name]').forEach(function (fs) {
        var values = [];
        fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
          var dot = r.parentNode.querySelector('.opt__dot');
          values.push({ value: r.value, hex: dot ? dot.style.getPropertyValue('--sw') : '' });
        });
        optionDefs.push({ name: fs.getAttribute('data-opt-name'), values: values });
      });
    }

    function bundleQty() {
      var r = bundle && bundle.querySelector('input[data-bundle-qty]:checked');
      return r ? +r.getAttribute('data-bundle-qty') : 1;
    }

    function variantFor(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === o; }); });
    }

    function rowOpts(row) {
      return Array.prototype.map.call(row.querySelectorAll('select'), function (s) { return s.value; });
    }

    function paintRow(row) {
      var opts = rowOpts(row);
      var v = variantFor(opts);
      var dot = row.querySelector('.bundle__dot');
      var colour = optionDefs[0] && optionDefs[0].values.find(function (x) { return x.value === opts[0]; });
      if (dot) dot.style.setProperty('--sw', colour && colour.hex ? colour.hex : 'transparent');
      row.classList.toggle('is-out', !v || !v.available);
      row.setAttribute('data-variant', v ? v.id : '');
    }

    function makeRow(n, opts) {
      var li = document.createElement('li');
      li.className = 'bundle__item';
      var label = (itemsBox.getAttribute('data-item-label') || 'Item [n]').replace('[n]', n);
      var html = '<span class="bundle__item-n">' + label + '</span><span class="bundle__dot" aria-hidden="true"></span>';
      optionDefs.forEach(function (def, i) {
        html += '<select aria-label="' + label + ' ' + def.name + '" data-opt-index="' + i + '">';
        def.values.forEach(function (x) {
          html += '<option value="' + x.value.replace(/"/g, '&quot;') + '"' + (x.value === opts[i] ? ' selected' : '') + '>' + x.value + '</option>';
        });
        html += '</select>';
      });
      li.innerHTML = html;
      paintRow(li);
      return li;
    }

    function syncItems(fromMain) {
      if (!itemsBox || !list || !optionDefs.length) return;
      var qty = bundleQty();
      itemsBox.hidden = qty < 2;
      var rows = list.querySelectorAll('.bundle__item');
      var base = current ? current.options : [];
      for (var n = rows.length; n > qty; n--) list.removeChild(rows[n - 1]);
      for (var m = rows.length; m < qty; m++) list.appendChild(makeRow(m + 1, base));
      var first = list.querySelector('.bundle__item');
      if (fromMain && first) {
        first.querySelectorAll('select').forEach(function (s, i) { if (base[i]) s.value = base[i]; });
        paintRow(first);
      }
      var ids = qty < 2 ? [] : Array.prototype.map.call(list.querySelectorAll('.bundle__item'), function (r) { return r.getAttribute('data-variant'); });
      form.setAttribute('data-bundle-ids', ids.join(','));
      if (btn && current) {
        var bad = ids.some(function (id) { return !id; }) || Array.prototype.some.call(list.querySelectorAll('.bundle__item'), function (r) { return qty > 1 && r.classList.contains('is-out'); });
        var active = bundle.querySelector('input[data-bundle-qty]:checked');
        var total = active ? active.closest('.bundle__row').querySelector('[data-bundle-total]') : null;
        if (qty > 1) {
          btn.disabled = bad;
          btn.textContent = bad ? btn.getAttribute('data-sold-label') : btn.getAttribute('data-add-label') + ' — ' + (total ? total.textContent : money(current.price * qty));
        } else {
          btn.disabled = !current.available;
          btn.textContent = current.available ? btn.getAttribute('data-add-label') + ' — ' + money(current.price) : btn.getAttribute('data-sold-label');
        }
      }
    }

    if (list) {
      list.addEventListener('change', function (e) {
        var row = e.target.closest('.bundle__item');
        if (!row) return;
        paintRow(row);
        syncItems(false);
      });
    }

    function paint() {
      if (!current) return;
      idInput.value = current.id;
      var price = info.querySelector('.pdp__price');
      var was = info.querySelector('.pdp__was');
      var save = info.querySelector('.pdp__save');
      if (price) price.textContent = money(current.price);
      if (was) {
        var on = current.compare_at_price > current.price;
        was.hidden = !on;
        if (on) was.textContent = money(current.compare_at_price);
      }
      if (save) {
        var pct = current.compare_at_price > current.price ? Math.round((1 - current.price / current.compare_at_price) * 100) : 0;
        save.hidden = !pct;
        if (pct) save.textContent = 'Save ' + pct + '%';
      }
      if (btn) {
        btn.disabled = !current.available;
        btn.textContent = current.available ? btn.getAttribute('data-add-label') + ' — ' + money(current.price) : btn.getAttribute('data-sold-label');
      }
      picker.querySelectorAll('[data-opt-current]').forEach(function (b) {
        b.textContent = current.options[+b.getAttribute('data-opt-current')] || '';
      });
      paintBundle();
      syncItems(true);
      if (current.featured_media && gallery) {
        var slide = gallery.querySelector('[data-media-id="' + current.featured_media.id + '"]');
        if (slide) gallery.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', current.id);
        history.replaceState(null, '', url);
      } catch (e) { /* no-op */ }
    }

    if (picker) {
      picker.addEventListener('change', function () {
        var opts = selected();
        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return opts[i] === undefined || opts[i] === o; });
        });
        if (match) { current = match; paint(); }
      });
    }

    if (bundle && qtyInput) {
      bundle.addEventListener('change', function (e) {
        var r = e.target.closest('input[data-bundle-qty]');
        if (r) qtyInput.value = r.getAttribute('data-bundle-qty');
        syncItems(false);
      });
    }

    // Colourway tiles further down the page pick the colour here instead of reloading.
    document.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-pick-colour]');
      if (!tile || !picker) return;
      var want = tile.getAttribute('data-pick-colour');
      var radio = Array.prototype.find.call(picker.querySelectorAll('input[type=radio]'), function (r) { return r.value === want; });
      if (!radio) return;
      e.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });

    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-size-guide]');
      if (!link) return;
      var acc = document.getElementById('size-guide');
      if (!acc) return;
      e.preventDefault();
      var q = acc.querySelector('.acc__q');
      if (q && q.getAttribute('aria-expanded') !== 'true') q.click();
      acc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function start() {
    document.querySelectorAll('form[data-product-form]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
}());
